'use client';

import { useTranslations } from 'next-intl';
import { FeatureDetailContent } from './FeatureDetailContent';
import {
    MessageSquare,
    Send,
    Users,
    Bell,
    CreditCard,
    Mail
} from 'lucide-react';

export function SmsIntegrationContent() {
    const t = useTranslations('smsIntegration');

    const features = [
        {
            icon: MessageSquare,
            title: t('features.step1.title'),
            description: t('features.step1.description'),
        },
        {
            icon: Send,
            title: t('features.step2.title'),
            description: t('features.step2.description'),
        },
        {
            icon: Users,
            title: t('features.step3.title'),
            description: t('features.step3.description'),
        },
        {
            icon: Bell,
            title: t('features.step4.title'),
            description: t('features.step4.description'),
        },
        {
            icon: CreditCard,
            title: t('features.step5.title'),
            description: t('features.step5.description'),
        },
        {
            icon: Mail,
            title: t('features.step6.title'),
            description: t('features.step6.description'),
        },
    ];

    const benefits = t.raw('benefits.list') as string[];

    return (
        <FeatureDetailContent
            pageKey="sms-integration"
            translationNamespace="smsIntegration"
            features={features}
            benefits={benefits}
            ctaIcon={MessageSquare}
            showWhatIsBitcoin={false}
            introImageSrc="/images/features/SMS.webp"
            introImageAlt={t('intro.imageAlt') || 'SMS Integration in MLM Software'}
            introParagraphKeys={['paragraph1', 'paragraph2']}
            introSectionHeadingPage="sms-integration"
            introSectionHeadingTitle={t('intro.sectionHeadingTitle') || 'About SMS Integration'}
            introSectionHeadingPill={t('intro.sectionHeadingPill') || 'SMS Integration'}
        />
    );
}

